import React from 'react';
import {BsFillPeopleFill, BsTelephone, BsBuildingFill} from 'react-icons/bs';
import {FaMobile, FaEnvelope} from 'react-icons/fa';
import {Route} from 'react-router';
import localization from '../localization/index';
import OrganizationsList from '../views/contacts/organizationList';
import PeopleList from '../views/contacts/personList';
import TemporaryUserList from '../views/contacts/temporaryUserList';
import {FOEDUS_ROLE} from '../domain/constants';
import EmailList from '../views/contacts/emailList';
import RegisteredDevicesList from '../views/contacts/regDevicesList';
import OrganizationDetail from '../views/contacts/organizationDetail';
import PersonDetail from '../views/contacts/personDetail';
import TemporaryUserDetail from '../views/contacts/temporaryUserDetail';
import {Redirect} from 'simplifyworks-core-ui';

const PATH_PREFIX = '/contacts/';
const KEY = 'contacts';
const NAME = 'CONTACTS';

const menu = {

	'foedusOrganizations': {
		icon: BsBuildingFill,
		labelKey: 'foedus-contacts-organizations',
		path: PATH_PREFIX + 'organizations',
		rolesAllowed: [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR],
		children: [
			{ labelKey: 'foedus-contacts-organizations', path: PATH_PREFIX + 'organizations' }
		]
	},

	'foedusPeople': {
		icon: BsFillPeopleFill,
		labelKey: 'foedus-contacts-people',
		path: PATH_PREFIX + 'people',
		rolesAllowed: [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR],
		children: [
			{ labelKey: 'foedus-contacts-people', path: PATH_PREFIX + 'people' }
		]
	},

	'foedusTemporaryUsers': {
		icon: BsFillPeopleFill,
		labelKey: 'foedus-contacts-temporary-users',
		path: PATH_PREFIX + 'temporary-users',
		rolesAllowed: [FOEDUS_ROLE.ADMIN],
		children: [
			{ labelKey: 'foedus-contacts-temporary-users', path: PATH_PREFIX + 'temporary-users' }
		]
	},

	'foedusEmails': {
		icon: FaEnvelope,
		labelKey: 'foedus-contacts-emails',
		path: PATH_PREFIX + 'emails',
		rolesAllowed: [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR],
		children: [
			{ labelKey: 'foedus-contacts-emails', path: PATH_PREFIX + 'emails' }
		]
	},

	'foedusRegisteredDevices': {
		icon: FaMobile,
		labelKey: 'foedus-contacts-registered-devices',
		path: PATH_PREFIX + 'registered-devices',
		rolesAllowed: [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR],
		children: [
			{ labelKey: 'foedus-contacts-registered-devices', path: PATH_PREFIX + 'registered-devices' }
		]
	}

};

const routes = [
	<Route path={PATH_PREFIX + 'my-account'} key={KEY + 'my-account'} components={PersonDetail} />,
	<Route path={PATH_PREFIX + 'organizations'} key={KEY + 'organizations'} components={OrganizationsList} rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]} />,
	<Route path={PATH_PREFIX + 'people'} key={KEY + 'people'} components={PeopleList} rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]} />,
	<Route path={PATH_PREFIX + 'temporary-users'} key={KEY + 'temporary-users'} components={TemporaryUserList} rolesAllowed={[FOEDUS_ROLE.ADMIN]} />,
	<Route path={PATH_PREFIX + 'registered-devices'} key={KEY + 'registered-devices'} components={RegisteredDevicesList} rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]} />,
	<Route path={PATH_PREFIX + 'emails'} key={KEY + 'emails'} components={EmailList} rolesAllowed={[FOEDUS_ROLE.ADMIN]} />,

	<Redirect from={PATH_PREFIX + 'people/:id'} to={PATH_PREFIX + 'people/:id/base-info'} />,
	<Route path={PATH_PREFIX + 'people/:id/:tabName'} key={KEY + 'people'} components={PersonDetail} rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]} />,

	<Redirect from={PATH_PREFIX + 'temporary-users/:id'} to={PATH_PREFIX + 'temporary-users/:id/base-info'} />,
	<Route path={PATH_PREFIX + 'temporary-users/:id/:tabName'} key={KEY + 'temporary-users-detail'} components={TemporaryUserDetail} rolesAllowed={[FOEDUS_ROLE.ADMIN]} />,

	<Redirect from={PATH_PREFIX + 'organizations/:id'} to={PATH_PREFIX + 'organizations/:id/base-info'} />,
	<Route path={PATH_PREFIX + 'organizations/:id/:tabName'} key={KEY + 'organizations'} components={OrganizationDetail} rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]} />
];

const Module = {
	name: NAME,
	key: KEY,
	icon: BsTelephone,
	portlets: [],
	menu: menu,
	routes: routes,
	localization: localization
};

export default Module;
